﻿import { BaseWidget } from "../BaseWidget";
import { TypeList } from "../Types";
import { BaseForm } from "./BaseForm";
import { RadioList } from "./RadioList";
import { Repeater, RepeaterItem } from "./Repeater";

export class F01_2014 extends BaseForm {
    private noticeTypes: TypeList = {
        PRI: "PRI_ONLY",
        RT: "PRI_REDUCING_TIME_LIMITS",
        CFC: "PRI_CALL_COMPETITION",
    };

    override updateForm() {
        this.defaultVisibility();
        this.NOTICE_TYPE_change();
        this.JOINT_PROCUREMENT_INVOLVED_change();
        this.ADDRESS_FURTHER_INFO_change();
        this.URL_TOOL_use_change();
        this.DOCUMENT_change();
        this.validateRepeatedElements();
    }

    defaultVisibility() {
        this.hideElement(this.findTagElementParent(this.ui.JOINT_PROCUREMENT_INVOLVED, "div"), false);
    }

    NOTICE_TYPE_change() {
        const objectRepeater: Repeater = this.muNamedWidget.OBJECT_CONTRACT as Repeater
        const val: string = this.muNamedWidget.NOTICE_TYPE.muFetchData();

        objectRepeater.maxCount = val === "PRI_ONLY" ? 100 : 1;
        objectRepeater.clearItems(objectRepeater.ui.items, 0);
        this.hideElement(objectRepeater.ui.bAddItem as HTMLElement, val === "PRI_ONLY");
        this.handleNoticeType();
    }

    JOINT_PROCUREMENT_INVOLVED_change() {
        const check: HTMLInputElement = this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement;

        //this.muVisible((this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked, "PROCUREMENT_LAW_block");
        this.hideElement(this.ui.PROCUREMENT_LAW_block, check.checked === true, false, false);

        //const addressRepeater: Repeater = this.muNamedWidget.ADDRESS_CONTRACTING_BODY as Repeater;

        //addressRepeater.maxCount = (this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked ? 500 : 1;
        //addressRepeater.clearItems(addressRepeater.ui.items, 0);
        //this.hideElement(addressRepeater.ui.bAddItem as HTMLElement, (this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked);

        //this.resetText(this.ui.PROCUREMENT_LAW);
    }

    /**
     * Příklad použití textarea
     * */
    //PROCUREMENT_LAW_input() {
    //    const textarea = (this.ui.PROCUREMENT_LAW as HTMLElement) as HTMLTextAreaElement;

    //    if (textarea.value.length > 200) {
    //        this.addErrorToElement(textarea, "Překročen limit znaků - 200");
    //    } else {
    //        this.removeErrorFromElement(textarea);
    //    }
    //}

    /**
     * Příklad použití number input
     * */
    //PROCUREMENT_LAW_input() {
    //    const numberInput = this.ui.PROCUREMENT_LAW as HTMLInputElement;

    //    if (parseInt(numberInput.value) > 1000) {
    //        this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (1000)");
    //    } else {
    //        this.removeErrorFromElement(numberInput);
    //    }
    //}

    CENTRAL_PURCHASING_change() {
        this.hideElement(document.querySelector('[mu-id="DPS_ADDITIONAL_PURCHASERS_block"]') as HTMLElement, this.ui.CENTRAL_PURCHASING.checked === true && (document.querySelector('[mu-id="DPS"]') as HTMLInputElement).checked === true);
    }

    ADDRESS_FURTHER_INFO_change() {
        const v = this.muNamedWidget.ADDRESS_FURTHER_INFO.muFetchData() as string;
        this.muVisible(v == "ADDRESS", "ADDRESS_FURTHER_INFO_ADDRESS");
    }
    URL_TOOL_use_change() {
        this.hideElement(this.ui.URL_TOOL.parentElement, (this.ui.URL_TOOL_use as HTMLInputElement).checked);
    }

    DOCUMENT_change() {
        const v = this.muNamedWidget.DOCUMENT.muFetchData() as string;
        if (v == "FULL")
            this.muVisible(v == "FULL", "url_restriction");
        else
            this.muVisible(v == "RESTRICTED", "url_restriction");
            
        this.removeErrorFromElement(this.ui.URL_DOCUMENT);
    }

    handleNoticeType() {
        /**
         * PRI_ONLY = PRI
         * PRI_REDUCING_TIME_LIMITS = RT
         * PRI_CALL_COMPETITION = CFC
         * */
        const val: string = this.muNamedWidget.NOTICE_TYPE.muFetchData();

        this.hideElement(this.findTagElementParent(this.ui.url_restriction, "div"), val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.ui.TENDER_PARTICIPATION as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(document.querySelector('[mu-id="DATE_PUBLICATION_NOTICE_block"]') as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.PRI);
        this.hideElement(document.querySelector('[mu-id="LOT_DIVISION_block"]') as HTMLElement, (val === this.noticeTypes.RT || val === this.noticeTypes.PRI) && (document.querySelector('[mu-bind="LOT_DIVISION"]')["widget"] as RadioList).muFetchData() === "LOT_DIVISION");
        this.hideElement(this.muNamedWidget.LEFTI.container as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.ADMINISTRATIVE_block as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.PROCEDURE_TYPE_block as HTMLElement, val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.FRAMEWORK_section as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.EAUCTION_block as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.RECEIPT_TENDERS_block as HTMLElement, val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.LANGUAGES_block as HTMLElement, val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.PROCEDURE.ui.DATE_AWARD_SCHEDULED_block as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElement(this.muNamedWidget.COMPLEMENTARY_INFO.ui.E_block as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC, false, false); 
        this.hideElement(this.muNamedWidget.COMPLEMENTARY_INFO.ui.PROC_REVIEW as HTMLElement, val === this.noticeTypes.RT || val === this.noticeTypes.CFC, false, false);
        this.hideElementsBy('mu-id', 'AC_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElementsBy('mu-id', 'VAL_OBJECT_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElementsBy('mu-id', 'DURATION_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC);
        this.hideElementsBy('mu-id', 'ACCEPTED_VARIANTS_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC); 
        this.hideElementsBy('mu-id', 'OPTIONS_use_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC); 
        this.hideElementsBy('mu-id', 'EU_PROGR_block', val === this.noticeTypes.RT || val === this.noticeTypes.CFC); 
    }

    validateRepeatedElements() {
        this.validateAllURLs();
        this.validateAllPhones();
        this.validateAllEmails();
    }

    validateAllURLs() {
        document.querySelectorAll('[type="url"]').forEach(url => this.addValidationToURL(url as HTMLInputElement));
    }

    validateAllPhones() {
        document.querySelectorAll('[mu-bind="PHONE"]').forEach(phone => this.addValidationToPhone(phone as HTMLInputElement));
        document.querySelectorAll('[mu-bind="FAX"]').forEach(phone => this.addValidationToPhone(phone as HTMLInputElement));
    }

    validateAllEmails() {
        document.querySelectorAll('[mu-bind="E_MAIL"]').forEach(email => this.addValidationToEmail(email as HTMLInputElement));
    }

    addValidationToURL(url: HTMLInputElement) {
        url.addEventListener('input', () => {
            const val: string = url.value;

            if (this.isValidURL(val) === false) {
                this.addErrorToElement(url, "Zadejte validní URL ve tvaru - http(s)://(www.)domena.cz");
            } else {
                this.removeErrorFromElement(url);
            }
        });
    }

    addValidationToPhone(phone: HTMLInputElement) {
        phone.addEventListener('change', () => {
            const isValid: true | string = this.checkFormat(phone, "Phone");

            if (isValid !== true) {
                this.addErrorToElement(phone, isValid);
            } else {
                this.removeErrorFromElement(phone);
            }
        });
    }

    addValidationToEmail(email: HTMLInputElement) {
        email.addEventListener('change', () => {
            const isValid: true | string = this.checkFormat(email, "Email");

            if (isValid !== true) {
                this.addErrorToElement(email, isValid);
            } else {
                this.removeErrorFromElement(email);
            }
        });

    }
    
    //RESTRICTED_change() {
    //    this.muVisible()
    //}
}

export class F01_2014_PARTICIPATION extends BaseWidget {
    updateForm() {
        this.TYPE_change();
        this.URL_PARTICIPATION_use_change();
    }

    TYPE_change() {
        const v = this.muNamedWidget.TYPE.muFetchData() as string;
        this.muVisible(v == "ADDRESS", "ADDRESS_TP");
        //this.muVisible(v == "URL", "URL_block");
    }

    URL_PARTICIPATION_use_change() {
        this.muVisible((this.ui.URL_PARTICIPATION_use as HTMLInputElement).checked, "URL_PARTICIPATION_block");
    }

}

export class OBJECT_CONTRACT_ITEM extends RepeaterItem {
    private contractType: string = "";
    private cpvValidation: (event: Event) => any;

    afterIndex(): void {
        this.LOT_DIVISION_change();
        this.SUB_LOT_DIVISION_change();
        this.LOT_MAX_ONE_TENDERER_use_change();
        this.LOT_COMBINING_CONTRACT_use_change();
    }

    LOT_DIVISION_change() {
        const v: RadioList = this.muNamedWidget.LOT_DIVISION as RadioList;
        const val: string = v.muFetchData() ?? "";
        const descr: Repeater = this.muNamedWidget.OBJECT_DESCR as Repeater;
        //poupravit
        this.hideElement(descr.ui.bAddItem, val === "LOT_DIVISION");
        this.hideElement(this.ui.LOT_DIVISION_block, val === "LOT_DIVISION" && (this.muParent.muParent.muNamedWidget.NOTICE_TYPE.muFetchData() === "PRI_REDUCING_TIME_LIMITS" || this.muParent.muParent.muNamedWidget.NOTICE_TYPE.muFetchData() === "PRI_CALL_COMPETITION"));
        this.hideElementsBy('mu-id', 'TITLE_block', val === "LOT_DIVISION");

        if(val !== "LOT_DIVISION")
        {
            descr.clearItems(descr.ui.items, 0);
        }
	}

    SUB_LOT_DIVISION_change() {
        const v = this.muNamedWidget.SUB_LOT_DIVISION as RadioList;
        const descr = this.muNamedWidget.OBJECT_DESCR as Repeater;
        //poupravit
        this.hideElement(this.ui.LOT_MAX_NUMBER.parentElement, v.muFetchData() === "LOT_MAX_NUMBER");
    }
    
    LOT_MAX_ONE_TENDERER_use_change() {
        this.hideElement(this.ui.LOT_MAX_ONE_NUMBER.parentElement, this.ui.LOT_MAX_ONE_TENDERER_use.checked === true);
    }

    LOT_COMBINING_CONTRACT_use_change() {
        this.hideElement(this.ui.LOT_COMBINING_CONTRACT_block, this.ui.LOT_COMBINING_CONTRACT_use.checked === true);
    }

    LOT_MAX_NUMBER_change() {
        const descr = this.muNamedWidget.OBJECT_DESCR as Repeater;

        if(this.ui.LOT_MAX_NUMBER.valueAsNumber > descr.muGetChildWidgets(descr.ui.items).length)
        {
            this.addErrorToElement(this.ui.LOT_MAX_NUMBER, "Hodnota nemůže být vyšší než celkový počet částí");
        } else {
            this.removeErrorFromElement(this.ui.LOT_MAX_NUMBER);
        }
    }

    LOT_MAX_ONE_NUMBER_change() {
        const descr = this.muNamedWidget.OBJECT_DESCR as Repeater;

        if(this.ui.LOT_MAX_ONE_NUMBER.valueAsNumber > descr.muGetChildWidgets(descr.ui.items).length)
        {
            this.addErrorToElement(this.ui.LOT_MAX_ONE_NUMBER, "Hodnota nemůže být vyšší než celkový počet částí");
        } else {
            this.removeErrorFromElement(this.ui.LOT_MAX_ONE_NUMBER);
        }
    }

    TYPE_CONTRACT_change() {
        const v: RadioList = this.muNamedWidget.TYPE_CONTRACT as RadioList;
        this.contractType = v.muFetchData() ?? "";
        this.validateAllCPVs();
        this.triggerAllCPVs();
        this.hideElement(document.querySelector('[mu-id="PARTICULAR_PROFESSION_block"]') as HTMLElement, this.contractType === "SERVICES");
    }

    validateAllCPVs() {
        document.querySelectorAll('[mu-bind="CPV_CODE"]').forEach(cpv => this.addValidationToCPV(cpv as HTMLInputElement));
    }

    triggerAllCPVs() {
        const ev: Event = new Event("input");

        document.querySelectorAll('[mu-bind="CPV_CODE"]').forEach(cpv => cpv.dispatchEvent(ev));
    }

    addValidationToCPV(cpv: HTMLInputElement) {
        cpv.removeEventListener('input', this.cpvValidation);
        this.cpvValidation = (event: Event) => this.validateCPV(cpv, event);
        cpv.addEventListener('input', this.cpvValidation);
    }
    
    validateCPV(cpv: HTMLInputElement, event: Event) {
        const val: string = cpv.value;
    
        if (this.validateMainCPVCode(val, this.contractType) === false && cpv.value.length > 1) {
            this.addErrorToElement(cpv, "Zadejte validní CPV pro tento typ zakázky");
        } else {
            this.removeErrorFromElement(cpv);
        }
    }
}

export class OBJECT_DESCR_ITEM extends RepeaterItem {
    afterIndex(): void {
        this.AC_change();
        this.RENEWAL_use_change();
        this.OPTIONS_use_change();
        this.EU_PROGR_change();
    }

    AC_change() {
        const v: RadioList = this.muNamedWidget.AC as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.SPECIFIC_CRITERIA as HTMLElement, val === "AC");
    }

    RENEWAL_use_change() {
        this.hideElement(this.ui.RENEWAL_block, this.ui.RENEWAL_use.checked === true);
    }

    OPTIONS_use_change() {
        this.hideElement(this.ui.OPTIONS_block, this.ui.OPTIONS_use.checked === true);
    }

    EU_PROGR_change() {
        const v: RadioList = this.muNamedWidget.EU_PROGR as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.EU_PROGR_RELATED_block, val === "EU_PROGR_RELATED");
    }
}

export class SPECIFIC_CRITERIA extends BaseWidget {
    afterIndex(): void {
        this.muAfterBindData();
    }
    muAfterBindData(): void {
        this.AC_QUALITY_use_change();
        this.AC_COST_radio_change();
    }

    AC_QUALITY_use_change() {
        this.hideElement(this.muNamedWidget.AC_QUALITY_block.container as HTMLElement, this.ui.AC_QUALITY_use.checked === true);
    }

    AC_COST_radio_change() {
        const v: RadioList = this.muNamedWidget.AC_COST_radio as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.muNamedWidget.AC_COST_block.container as HTMLElement, val === "AC_COST");
        this.hideElement(this.ui.AC_PRICE_block as HTMLElement, val === "AC_PRICE");
    }
}

export class LEFTI extends BaseWidget {
    afterIndex(): void {
        this.ECONOMIC_CRITERIA_DOC_change();
    }

    ECONOMIC_CRITERIA_DOC_change() {
        this.hideElement(this.ui.ECONOMIC_CRITERIA_block, this.ui.ECONOMIC_CRITERIA_DOC.checked !== true);
    }

    TECHNICAL_CRITERIA_DOC_change() {
        this.hideElement(this.ui.TECHNICAL_CRITERIA_block, this.ui.TECHNICAL_CRITERIA_DOC.checked !== true);
    }
}

export class PROCEDURE extends BaseWidget {
    afterIndex(): void {
        this.FRAMEWORK_use_change();
        this.ProcedureType_change();
        this.ProcedureType2_change();
        this.DPS_change();
        this.EAUCTION_USED_change();
    }

    FRAMEWORK_use_change() {
        this.hideElement(this.ui.FRAMEWORK_block, this.ui.FRAMEWORK_use.checked === true);
        this.hideElement(this.ui.JUSTIFICATION_block, this.ui.FRAMEWORK_use.checked === true);
    }

    ProcedureType_change() {
        this.hideElement(this.ui.DPS_block as HTMLElement, this.muNamedWidget.ProcedureType.muFetchData() === "PT_RESTRICTED");
    }

    ProcedureType2_change() {
        const v: RadioList = this.muNamedWidget.ProcedureType2 as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.SEVERAL_OPERATORS_block as HTMLElement, val === "SEVERAL_OPERATORS");
    }

    DPS_change() {
        this.hideElement(this.ui.DPS_ADDITIONAL_PURCHASERS_block, this.ui.DPS.checked === true && (document.querySelector('[mu-id="CENTRAL_PURCHASING"]') as HTMLInputElement).checked === true);
    }

    EAUCTION_USED_change() {
        this.hideElement(this.ui.INFO_ADD_EAUCTION_block, this.ui.EAUCTION_USED.checked);
    }
}

export class COMPLEMENTARY_INFO extends BaseWidget {
    override afterIndex() {
        this.prefillSelects();
    }

    prefillSelects() {
        this.container.querySelectorAll('select[mu-id="COUNTRY"]').forEach(s => (s as HTMLSelectElement).selectedIndex = 1)
    }

}